import gql from 'graphql-tag';

const CANCEL_ORDER = gql`
  mutation cancelOrder {
    cancelOrder
  }
`;

export {CANCEL_ORDER};
